import { PostitService } from './../services/postit.service';
import { Estate } from '../utils/enum.util';

export class PostitModel {

    private _privateId: string;
    private _content: string       = '';
    private _contentScreen: string = '';
    private _created: Date;
    private _updated: Date;
    private _customers: any = [];
    private _state: Estate         = Estate.Save;
    private _textZone: any;
    private _search: string = null;
    private _customer: string = null;
    private _isArchive: boolean;
    private _searchResult: any[];
    public view;

    //*************************************
    //************ CONSTRUCTOR ************
    //*************************************
    constructor(public _postitService: PostitService) {

    };

    //*************************************
    //*************** ACTION **************
    //*************************************
    public modalChange(textZone) {
        this._textZone      = textZone;
        this._contentScreen = textZone.nativeElement.innerHTML;
        this.state = Estate.Saving;

        //retire toute les balise de style
        while (this._contentScreen.match(/<(?!li contenteditable="false"|span contenteditable="false"|\/|div|br)(.*?)>(.*?)<\/(.*?)>/g) != null) {
            this._contentScreen = this._contentScreen.replace(/<(?!li contenteditable="false"|span contenteditable="false"|\/|div|br)(.*?)>(.*?)<\/(.*?)>/g, this.replacerStyle);
            this.refresh();
        }

        //check si il y a un insert ( @)
        let regex = /(^| |&nbsp;|\n|>)@(([^\W]+)?( )?([^\W]+))/g;
        let insert = regex.exec(this.contentScreen);
        if (insert != null) {
            this._postitService.isOpen = true;
            this.search = insert[2];
            this.searchCustomer();
        } else {
            this.search = null;
            this._postitService.isOpen = false;
            //si un client a été mis, on enregistre (et refresh)
            if (this._contentScreen.match(/\[.{24}\]/g) != null) {
                this.screenToContent();
                if (this.privateId)
                    this.update(true);
                else
                    this.create(true);
            } else {
                this.screenToContent();
                this.formatContentScreen();
                if (this.privateId)
                    this.update();
                else
                    this.create();
            }
        }
    }

    public update(force: boolean = false) {
        this._postitService.update(this, force);
    }

    public create(force: boolean = false) {
        this._postitService.create(this, force);
    }

    public delete(){
        this._postitService.delete(this);
    }

    public unDelete(){
        this._postitService.unDelete(this);
    }

    //*************************************
    //************* VALIDATOR *************
    //*************************************
    public searchSelected(_customer){
        let regex = new RegExp('@' + this.search, 'g');
        this._contentScreen = this._contentScreen.replace(regex, '[' + _customer._id + ']');
        if (_customer.firstName) {
            this.customers.push({
                beenContacted: _customer.beenContacted,
                firstName    : _customer.firstName,
                lastName     : _customer.lastName,
                mobile       : _customer.phone.mobile,
                privateId    : _customer._id,
            });
        }
        this.search = null;
        this._searchResult = [];
        this.screenToContent();
        this.refresh();
        if (this.view)
            this.view.addEventOnCustomer();
        if (this.privateId)
            this.update();
        else
            this.create();
    }

    public searchCustomer(){
        if (this.search.length > 0)
            this._postitService.search(this);
        else
            this.searchResult = [];
    }

    public refresh() {
        this.formatContentScreen();
        if (this._textZone && this._textZone.nativeElement)
            this._textZone.nativeElement.innerHTML = this._contentScreen;
    }

    public formatContentScreen() {
        this._contentScreen = this._contentScreen.replace(/\[.{24}\]/g, (match, _offset, _string)=> {
            let customer = this.getClientById(match.slice(1, -1));
            if (customer && customer.lastName && customer.beenContacted)
                return '<li contenteditable="false"><span contenteditable="false" id="' + match.slice(1, -1) + '">' + customer.lastName + ' ' + customer.firstName + ' ✔</i></span></li>&nbsp;';
            if (customer && customer.lastName)
                return '<li contenteditable="false"><span contenteditable="false" id="' + match.slice(1, -1) + '">' + customer.lastName + ' ' + customer.firstName + '</span></li>&nbsp;';
            return '<li contenteditable="false"><span contenteditable="false">client supprimé</span></li>&nbsp;';
        });
    }

    public contentToScreen() {
        this.contentScreen = this.content;
        this.formatContentScreen();
    }

    public screenToContent() {
        this._content = this._contentScreen.replace(/<li contenteditable=\"false\"><span contenteditable=\"false\" id=\"(.{24})\">(.*?)<\/span><\/li>/g, this.replacer2);
    }

    public replacer2(_match, offset, _string): string {
        return '[' + offset.toString() + ']';
    }

    public replacerStyle(_match, _offset, _string): string {
        return _string;
    }

    public getClientById(id: string): any {
        let customerSelected = null;
        if (this.customers) {
            this.customers.forEach((customer)=> {
                if (customer.privateId == id || customer._id == id) {
                    customerSelected = customer;
                    return true;
                }
            });
        }
        return customerSelected;
    }

    //*************************************
    //************** METHOD ***************
    //*************************************


    //*************************************
    //********** GETTER / SETTER **********
    //*************************************
    get privateId(): string {
        return this._privateId;
    }

    set privateId(value: string) {
        this._privateId = value;
    }

    get content(): string {
        return this._content;
    }

    set content(value: string) {
        this._content = value;
    }

    get created(): Date {
        return this._created;
    }

    set created(value: Date) {
        this._created = value;
    }

    get updated(): Date {
        return this._updated;
    }

    set updated(value: Date) {
        this._updated = value;
    }

    get customers(): any {
        return this._customers;
    }

    set customers(value: any) {
        this._customers = value;
    }

    get state(): Estate {
        return this._state;
    }

    set state(value: Estate) {
        this._state = value;
    }

    get contentScreen(): string {
        return this._contentScreen;
    }

    set contentScreen(value: string) {
        this._contentScreen = value;
    }

    get textZone(): any {
        return this._textZone;
    }

    set textZone(value: any) {
        this._textZone = value;
    }

    get search(): string {
        return this._search;
    }

    set search(value: string) {
        this._search = value;
    }

    get searchResult(): any[] {
        return this._searchResult;
    }

    set searchResult(value: any[]) {
        this._searchResult = value;
    }

    get customer(): string {
        return this._customer;
    }

    set customer(value: string) {
        this._customer = value;
    }

    get isArchive(): boolean {
        return this._isArchive;
    }

    set isArchive(value: boolean) {
        this._isArchive = value;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/models/postit.model.ts